import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import * as Highcharts from 'highcharts';
import {Options} from 'highcharts';
import {TrendChartService} from "../../services/trend-chart/trend-chart.service";
import moment from "moment";

import highchartsRounded from 'highcharts-rounded-corners';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';

highchartsRounded(Highcharts)

declare module 'highcharts' {
  interface Point {
      custom: any
  }
}

@Component({
  selector: 'app-pulse-perf-trend',
  templateUrl: './pulse-perf-trend.component.pug',
  styleUrls: ['./pulse-perf-trend.component.scss'],
  standalone: false
})
export class PulsePerfTrendComponent implements OnInit, OnChanges {


  @Input() perfTrend: any = { result: [], result_type: '', start: '', end: '' };
  updateFlag = false;
  difference:any;
  tickPositions:any = [];

  dateFormat: any = new Map([
    ["dates", "YYYY-MM-DD"],
    ["weeks", "YYYY_W"],
    ["months", "YYYY_MM"],
    ["quarters", "YYYY_Q"],
    ["years", "YYYY"],
  ]);

  Highcharts: typeof Highcharts = Highcharts;

  title: Highcharts.TitleOptions = {
    text: `-`,
    align: 'left',
    style: {"fontFamily": "TT Commons", fontWeight: 'normal', fontSize: "18px"}
  }

  subtitle: Highcharts.SubtitleOptions = {
    text: $localize`Displaying ${this.totalRequests} requests`,
    align: 'left',
    style: {"fontFamily": "TT Commons"}
  }

  tooltip: Highcharts.TooltipOptions = {
    enabled: true,
    backgroundColor: 'white',
    borderWidth: '0',
    padding: 12,
    distance: 16,
    borderRadius: 4,
    shadow: true,
    useHTML: true,
    outside: true,
    formatter: function() {
      const tooltipFormat: any = new Map([
        ["dates", "D MMM YYYY"],
        ["weeks", "[Week starting] D MMM YYYY"],
        ["months", "MMMM YYYY"],
        ["quarters", "[Q]Q, YYYY"],
        ["years", "YYYY"],
      ]);

      return  `
      <div class='participation-tooltip' style="width:140px">
      <span class='tooltip-heading' *ngIf="featureFlagEnt5038">${moment.unix(this.x as number / 1000).format(tooltipFormat.get(this.point.custom.result_type))}</span>
        <div class='tooltip-point'>
          <div class='tooltip-row'><b style='color:#32735F'>${this.point.custom.completed}</b> Completed</div>
          <div class='tooltip-row'><b style='color:#000000'>${this.point.custom.stopped}</b> Stopped</div>
        </div>
      </div>`;
    },
    style: {
      fontFamily: 'TT Commons',
      fontWeight: '500',
      fontSize: '14px',
      padding: '0px',
      width: 135
    }
  }

  legend: Highcharts.LegendOptions = {
    enabled: false,
  }

  series: any = [
    {
      type: "column",
      pointWidth: 12,
      borderRadiusTopLeft: 2,
      borderRadiusTopRight: 2,
    }
  ]

  chartOptions: Options = TrendChartService.getOptions(
    this.perfTrend['result'], 0, 10, 300, 800, '#FFF', 'rgb(50,115,95)', 'rgb(255, 255, 255)', ['#32735F', '#EAF1EF'], 'months', this.title, this.subtitle, this.tooltip, this.legend, this.series);

  get totalRequests() {
    return this.perfTrend["result"].reduce((a, b) => { return a + b.completed + b.stopped }, 0)
  }

  constructor(private permissionService: PermissionsService) {}

  ngOnInit(): void {
    this.tooltip.outside = false;
  }

  ngOnChanges(changes: SimpleChanges): void {
    let result_type = this.dateFormat.get(this.perfTrend['query_type']);
    let series: any = [];
    let lastPoint = -Infinity;
    this.tickPositions = [];

    // If there is no data just return
    if(Array.isArray(this.perfTrend)) {
      this.updateFlag = true;
      return;
    }

    for (let i = 0; i < this.perfTrend["result"].length; i++) {
      let d = this.perfTrend["result"][i];
      let date = moment.utc(d['date'], result_type).toDate().getTime();
      let min_diff = (this.perfTrend.end.diff(this.perfTrend.start)) / 7;
      let currentPoint = date;
      let diff =  currentPoint - lastPoint;
      if ((i == 0 || i == this.perfTrend["result"].length - 1 || (diff > min_diff))) {
        lastPoint = currentPoint;
        this.tickPositions.push(currentPoint);
      }
      series.push({ x: date, y: Math.round(((9 * (d['value'] - 1)) / 4) + 1), custom: { completed: d.completed, stopped: d.stopped, result_type: this.perfTrend['query_type'] ? this.perfTrend['query_type'] : 'dates', } });

    }
    let label_format = '';
    if (this.perfTrend['query_type'] == 'years') {
      label_format = 'YYYY';
    } else if (this.perfTrend['query_type'] == 'quarters') {
      label_format = '[Q]Q, YYYY';
    } else if (this.perfTrend['query_type'] == 'months') {
      label_format = 'MMMM YYYY';
    } else if (this.perfTrend['query_type'] == 'dates' || this.perfTrend['query_type'] == 'weeks') {
      label_format = 'DD MMM YYYY';
    }
    else {
      label_format = 'L';
    }
    // Update chart titles based on new data
    this.chartOptions.title = { text: `${moment(this.perfTrend.start).format(label_format)} - ${moment(this.perfTrend.end).format(label_format)}` }

    let requestCount = this.totalRequests;
    if (requestCount === 1) {
      this.chartOptions.subtitle = {text: $localize`Displaying ${requestCount} request`};
    } else {
      this.chartOptions.subtitle = {text: $localize`Displaying ${requestCount} requests`};
    }

    this.chartOptions.xAxis = {'tickPositions': this.tickPositions};
    this.chartOptions.yAxis = {tickInterval:2};
    let trend_chart_result_type = this.perfTrend['query_type'];
    if (this.perfTrend['query_type'] == 'weeks') { trend_chart_result_type = 'pulse_weeks'; }
    if (this.perfTrend['query_type'] == 'months') { trend_chart_result_type = 'pulse_months'; }
    TrendChartService.setChartOptionsFromData(this.chartOptions, series, trend_chart_result_type);
    const resultType = this.perfTrend['query_type'];
    this.chartOptions.xAxis = {
      type: 'datetime',
      tickPositions: this.tickPositions,
      labels: {
        rotation: 0,
        align: 'center',
        style: {
          fontSize: '12px',
          fontFamily: 'TT Commons'
        },
        formatter: function () {
          let line1 = '';
          let line2 = '';

          if (resultType === 'years') {
            return moment(this.value).format('YYYY');
          } else if (resultType === 'quarters') {
            line1 = moment(this.value).format('[Q]Q');
            line2 = moment(this.value).format('YYYY');
          } else if (resultType === 'months') {
            line1 = moment(this.value).format('MMM');
            line2 = moment(this.value).format('YYYY');
          } else {
            line1 = moment(this.value).format('DD MMM');
            line2 = moment(this.value).format('YYYY');
          }

          return `${line1}<br><div style="text-align:center">${line2}</div>`;
        },
        useHTML: true
    }
};
    this.updateFlag = true;
  }
}
